var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1000px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', _vm._b({}, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-title', {
    staticClass: "subtitle-1",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(" API 테스트 주문 "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "absolute": "",
      "right": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.shows = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('giftcard-cp-price-dialog-info', _vm._b({}, 'giftcard-cp-price-dialog-info', {
    value: _vm.selectedGiftcard
  }, false)), _c('v-divider'), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card-subtitle', [_vm._v("요청 정보")]), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.platforms,
      "label": "platform"
    },
    model: {
      value: _vm.form.platform,
      callback: function ($$v) {
        _vm.$set(_vm.form, "platform", $$v);
      },
      expression: "form.platform"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.giftcards.filter(function (giftcard) {
        return giftcard.platform == _vm.form.platform;
      }),
      "item-text": function (_ref2) {
        var name = _ref2.name,
          cpamt = _ref2.cpamt;
        return `${name} (${cpamt.format()})원`;
      },
      "return-object": "",
      "label": "giftcard"
    },
    on: {
      "change": function () {
        _vm.form._giftcard = _vm.selectedGiftcard._id;
      }
    },
    model: {
      value: _vm.selectedGiftcard,
      callback: function ($$v) {
        _vm.selectedGiftcard = $$v;
      },
      expression: "selectedGiftcard"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "주문번호"
    },
    model: {
      value: _vm.form.orderNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "orderNo", $$v);
      },
      expression: "form.orderNo"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.cps,
      "label": "CP"
    },
    model: {
      value: _vm.form._cp,
      callback: function ($$v) {
        _vm.$set(_vm.form, "_cp", $$v);
      },
      expression: "form._cp"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "구매수량"
    },
    model: {
      value: _vm.form.quantity,
      callback: function ($$v) {
        _vm.$set(_vm.form, "quantity", $$v);
      },
      expression: "form.quantity"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "발신자 성함"
    },
    model: {
      value: _vm.form.sender.name,
      callback: function ($$v) {
        _vm.$set(_vm.form.sender, "name", $$v);
      },
      expression: "form.sender.name"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "발신자 연락처"
    },
    model: {
      value: _vm.form.sender.phone,
      callback: function ($$v) {
        _vm.$set(_vm.form.sender, "phone", $$v);
      },
      expression: "form.sender.phone"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "발신자 이메일"
    },
    model: {
      value: _vm.form.sender.email,
      callback: function ($$v) {
        _vm.$set(_vm.form.sender, "email", $$v);
      },
      expression: "form.sender.email"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "수신자 성함"
    },
    model: {
      value: _vm.form.receiver.name,
      callback: function ($$v) {
        _vm.$set(_vm.form.receiver, "name", $$v);
      },
      expression: "form.receiver.name"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "수신자 연락처"
    },
    model: {
      value: _vm.form.receiver.phone,
      callback: function ($$v) {
        _vm.$set(_vm.form.receiver, "phone", $$v);
      },
      expression: "form.receiver.phone"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "수신자 이메일"
    },
    model: {
      value: _vm.form.receiver.email,
      callback: function ($$v) {
        _vm.$set(_vm.form.receiver, "email", $$v);
      },
      expression: "form.receiver.email"
    }
  })], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card-subtitle', [_vm._v("요청 응답")]), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "CP명",
      "readonly": ""
    },
    model: {
      value: _vm.result.cp.name,
      callback: function ($$v) {
        _vm.$set(_vm.result.cp, "name", $$v);
      },
      expression: "result.cp.name"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "주문 후 CP 캐시",
      "readonly": ""
    },
    model: {
      value: _vm.result.cp.remainCash,
      callback: function ($$v) {
        _vm.$set(_vm.result.cp, "remainCash", $$v);
      },
      expression: "result.cp.remainCash"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "상품권명",
      "readonly": ""
    },
    model: {
      value: _vm.result.giftcard.name,
      callback: function ($$v) {
        _vm.$set(_vm.result.giftcard, "name", $$v);
      },
      expression: "result.giftcard.name"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "주문 후 재고",
      "readonly": ""
    },
    model: {
      value: _vm.result.giftcard.remainStock,
      callback: function ($$v) {
        _vm.$set(_vm.result.giftcard, "remainStock", $$v);
      },
      expression: "result.giftcard.remainStock"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "주문번호",
      "readonly": ""
    },
    model: {
      value: _vm.result.order.orderNo,
      callback: function ($$v) {
        _vm.$set(_vm.result.order, "orderNo", $$v);
      },
      expression: "result.order.orderNo"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "주문 일자",
      "readonly": ""
    },
    model: {
      value: _vm.result.order.orderedAt,
      callback: function ($$v) {
        _vm.$set(_vm.result.order, "orderedAt", $$v);
      },
      expression: "result.order.orderedAt"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "API 가격",
      "readonly": ""
    },
    model: {
      value: _vm.result.order.cpamt,
      callback: function ($$v) {
        _vm.$set(_vm.result.order, "cpamt", $$v);
      },
      expression: "result.order.cpamt"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "API 할인율",
      "readonly": ""
    },
    model: {
      value: _vm.result.order.discountRate,
      callback: function ($$v) {
        _vm.$set(_vm.result.order, "discountRate", $$v);
      },
      expression: "result.order.discountRate"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "개수",
      "readonly": ""
    },
    model: {
      value: _vm.result.order.quantity,
      callback: function ($$v) {
        _vm.$set(_vm.result.order, "quantity", $$v);
      },
      expression: "result.order.quantity"
    }
  })], 1), _c('v-col', {
    staticClass: "px-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "주문 총 가격",
      "readonly": ""
    },
    model: {
      value: _vm.result.order.salesAmount,
      callback: function ($$v) {
        _vm.$set(_vm.result.order, "salesAmount", $$v);
      },
      expression: "result.order.salesAmount"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "text": ""
    },
    on: {
      "click": function () {
        return _vm.shows = false;
      }
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.order
    }
  }, [_vm._v("주문")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }